module.exports = new __parcel__URL__("add-link-disabled.7b05b6be.svg").toString();